import { render } from "./LiveShipmentStatusChart.vue?vue&type=template&id=a1dffd3e&ts=true"
import script from "./LiveShipmentStatusChart.vue?vue&type=script&lang=ts"
export * from "./LiveShipmentStatusChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__